import { render, staticRenderFns } from "./TechAreasPageIndex.vue?vue&type=template&id=e44ab134&"
import script from "./TechAreasPageIndex.vue?vue&type=script&lang=ts&"
export * from "./TechAreasPageIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e44ab134')) {
      api.createRecord('e44ab134', component.options)
    } else {
      api.reload('e44ab134', component.options)
    }
    module.hot.accept("./TechAreasPageIndex.vue?vue&type=template&id=e44ab134&", function () {
      api.rerender('e44ab134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/TechAreas/TechAreasPageIndex.vue"
export default component.exports